export const InterestsAndSkills = {
  title: 'INTERESTS_AND_SKILLS.TITLE',
  description: 'INTERESTS_AND_SKILLS.DESCRIPTION',
};
